import React from "react"
import {
  BarChart,
  Bar,
  LabelList,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts"
import {chartsPallete} from "../../../assets/shared/colorConstants"
import dayjs from "dayjs"
import ChartTooltip from "../ChartTooltip"

const LegendBarChart = ({
  chartData,
  xDataKey,
  labelList,
  barSize,
  barGap,
  chartHeight,
  paddingTop,
  marginRight,
  legendPosBottom,
}) => {
  const drawBars = () => {
    const data = chartData || []
    const dataSet = data[0],
      barArr = []
    let count = 0
    for (let i in dataSet) {
      if (dataSet.hasOwnProperty(i) && i !== xDataKey) {
        barArr.push(
          <Bar key={`bar-chart-${count}`} dataKey={i} fill={chartsPallete[count]}>
            {labelList && (
              <LabelList
                className={`label-list label-${count}`}
                dataKey={i}
                position="top"
                fill="#000"
                formatter={(val) => `${val}%`}
              />
            )}
          </Bar>
        )
        count++
      }
    }
    return barArr
  }

  return (
    <ResponsiveContainer height={chartHeight ? chartHeight : 213} width="100%">
      <BarChart
        data={chartData}
        margin={{top: 40, right: marginRight ? marginRight : 0}}
        barGap={barGap ? barGap : 1}
        barSize={barSize}
      >
        <CartesianGrid vertical={false} strokeOpacity="0.6" strokeDasharray="4 4" />
        <XAxis
          dataKey={xDataKey}
          strokeOpacity="0.1"
          tickLine={false}
          strokeDasharray="4 4"
          tick={xDataKey === "Month" ? {dy: 15} : {dy: 5}}
          tickFormatter={
            xDataKey === "Month" ? (tick) => dayjs(tick).format("MMMM YYYY") : null
          }
        />
        <YAxis axisLine={false} tickLine={false} tickFormatter={(tick) => `${tick}%`} />
        <Tooltip
          formatter={function (value, name) {
            return `${value}%`
          }}
          labelFormatter={function (value) {
            return `${xDataKey === "Month" ? dayjs(value).format("MMMM YYYY") : value}`
          }}
          xDataKey={xDataKey}
          content={<ChartTooltip />}
        />
        {drawBars()}
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          iconSize={12}
          align="center"
          wrapperStyle={{
            bottom: legendPosBottom ? legendPosBottom : 0,
            left: 40,
            color: "#485465",
            paddingTop: paddingTop ? paddingTop : 0,
          }}
        />
        <ReferenceLine y={0} stroke="#0a3f36" />
      </BarChart>
    </ResponsiveContainer>
  )
}
export default LegendBarChart
